var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.selectedItem.length && _vm.view_only)?_c('fs1-div',[_vm._v("Sin imagenes")]):_vm._e(),_c('in_img',{staticStyle:{"display":"inline-block"},attrs:{"container":_vm.selectedItem,"c_key":"picture","multiple":true,"on_add":_vm.add_img,"on_remove":_vm.remove_img,"disabled":_vm.view_only,"auth_file_endpoint":_vm.authFileEndpoint}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }